import { Component, OnInit } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

@Component({
  selector: 'app-read-email',
  templateUrl: './read-email.component.html',
  styleUrls: ['./read-email.component.scss'],
})
export class ReadEmailComponent implements OnInit {
  public loading = false;
  isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(
      map((result) => result.matches),
      shareReplay(),
    );
  constructor(private breakpointObserver: BreakpointObserver) {}

  ngOnInit(): void {
    this.loading = true;
    setTimeout(()=>{
      this.loading = false;
    }, 3000)
  }
}
